import { render, staticRenderFns } from "./Send.vue?vue&type=template&id=0c2b8abe&scoped=true&"
import script from "./Send.vue?vue&type=script&lang=js&"
export * from "./Send.vue?vue&type=script&lang=js&"
import style0 from "./Send.vue?vue&type=style&index=0&id=0c2b8abe&lang=less&scoped=true&"
import style1 from "./Send.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b8abe",
  null
  
)

export default component.exports